import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import BookedLabel from 'tripPlanner/components/BookedLabel'
import { ItemMetadata } from 'tripPlanner/models'
import type { TripItem } from 'tripPlanner/types/tripItem'

const FlexOne = styled.div`
  flex: 1;
`

interface Props {
  item: TripItem
}

function ItemTypeAndBookedLabel({ item }: Props) {
  const intl = useIntl()
  return (
    <Group direction="horizontal" verticalAlign="start">
      <FlexOne>
        <Heading variant="heading4">
          {intl.formatMessage(ItemMetadata[item.type].singularName)}
        </Heading>
      </FlexOne>
      {item.type !== 'NOTE' && item.isBooked && <BookedLabel />}
    </Group>
  )
}

export default ItemTypeAndBookedLabel
